var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"valid-code-container"},[_c('canvas',{ref:"canvasRef",staticClass:"cursor-pointer",attrs:{"width":_vm.contentWidth,"height":_vm.contentHeight},on:{"click":_vm.refreshCode}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9a9ee90e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ValidCode.vue
// module id = null
// module chunks = 